import config from './../config';
import axios from 'axios';

export default {

    replaceRouteName(name) {

        const routes = {
            'webfonts-index': '/webfont'
        };

        let url = name;

        if (routes.hasOwnProperty(name)) {
            url = routes[name];
        }

        return url;

    },

    /**
     * Creates a full URL for an API route using the host in the configuration file and the predefined prefix
     * (defined in this method self) for API routes.
     * @param {string} route
     * @returns {string}
     */
    createUrl(route) {

        console.log(`${config.api.protocol}://${config.api.host}/api${route}`);
        return `${config.api.protocol}://${config.api.host}/api${route}`;

    },

    /**
     * Adds the domain if the API returns the complete ready route.
     * @param {string} completeRoute
     * @returns {string}
     */
    addDomainToRoute(completeRoute) {
        return `${config.api.protocol}://${config.api.domain}${completeRoute}`;
    },

    /**
     * @param {String} httpVerb
     * @param {String} apiRoute
     * @param {Object} requestBody
     * @param {Function} errorHandler
     * @param {Object} options can used to set custom header information
     * @returns {Promise<Object|null>} If successful, the data in the response or null.
     * @example requestApiRoute('get', `/image/${imageId}`)
     * @example requestApiRoute('post', `/image`, { key: 'value in post body', ... }, (err) => { // handling error })
     */
    async requestApiRoute(httpVerb, apiRoute, requestBody = {}, errorHandler = () => {}, options = {}) {

        let response = null;

        if (['get', 'post', 'put', 'delete', 'patch'].includes(httpVerb)) {

            try {
                response = await axios[httpVerb](this.createUrl( this.replaceRouteName(apiRoute) ), requestBody, options);
                response = response.data;
            } catch (error) { errorHandler(error) }

        }

        return response;

    }

};